import { hubStore } from '@/models/stores/hubs';
import { PDKSFSVGIcon } from '../pdk-icons';

export const HeaderRowWithHubSVG = ({
  hubPathIdentifier,
}: {
  hubPathIdentifier: string;
}) => {
  const hub = hubStore.getByPathIdentifier(hubPathIdentifier);
  const hubName = hub?.name ?? hubPathIdentifier;

  return (
    <div className="flex flex-row items-center gap-1 whitespace-nowrap">
      <PDKSFSVGIcon />
      <div>{hubName}</div>
    </div>
  );
};

export const HeaderRowWithCustomIcon = ({
  icon,
  copy,
}: {
  icon: React.ReactNode;
  copy: string;
}) => {
  return (
    <div className="flex flex-row items-center gap-1">
      {icon}
      <div>{copy}</div>
    </div>
  );
};
